/**
 * Tên và sự tồn tại của trang mà một video gắn vào: để thẻ video ghi
 * "Đọc tiếp: Vesting là gì", và để trang quản trị báo đường dẫn gõ sai.
 */
import { DA_XUAT_BAN, tuDienTheoSlug } from '../data/glossary.js';
import { PLAYBOOK_POSTS, playbookBySlug } from '../data/playbook.js';
import { TOOLS, toolBySlug } from '../data/tools.js';

export function tenTrang(path) {
  const m = /^\/(thuat-ngu|playbook|cong-cu)\/([^/]+)$/.exec(path || '');
  if (!m) return '';
  if (m[1] === 'thuat-ngu') { const x = tuDienTheoSlug(m[2]); return x?.status === 'PUBLISHED' ? x.term : ''; }
  if (m[1] === 'playbook') return playbookBySlug(m[2])?.title || '';
  return toolBySlug(m[2])?.title || '';
}

export const coTrang = (path) => Boolean(tenTrang(path));

/** Chữ để tìm: tên trang, cộng tên tiếng Anh và tên gọi khác của thuật ngữ. */
export function tuKhoaTrang(path) {
  const m = /^\/thuat-ngu\/([^/]+)$/.exec(path || '');
  const x = m ? tuDienTheoSlug(m[1]) : null;
  // Công cụ: thêm mã tiếng Anh (cap-table, runway…) và một câu mô tả.
  const c = /^\/cong-cu\/([^/]+)$/.exec(path || '');
  const t = c ? toolBySlug(c[1]) : null;
  return [tenTrang(path), ...(x?.aliases || []), t?.toolId, t?.blurb].filter(Boolean).join(' ');
}

/** Mọi trang gắn được video, cho ô gợi ý ở trang quản trị. */
export function cacTrangGanDuoc() {
  return [
    ...DA_XUAT_BAN.map((x) => ({ path: `/thuat-ngu/${x.slug}`, ten: `Từ điển: ${x.term}` })),
    ...PLAYBOOK_POSTS.map((p) => ({ path: `/playbook/${p.slug}`, ten: `Playbook: ${p.title}` })),
    ...TOOLS.map((t) => ({ path: `/cong-cu/${t.slug}`, ten: `Công cụ: ${t.title}` })),
  ];
}
